import { render, staticRenderFns } from "./psGoodItem.vue?vue&type=template&id=fdd3ab38&scoped=true&"
import script from "./psGoodItem.vue?vue&type=script&lang=js&"
export * from "./psGoodItem.vue?vue&type=script&lang=js&"
import style0 from "./psGoodItem.vue?vue&type=style&index=0&id=fdd3ab38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd3ab38",
  null
  
)

export default component.exports